import { ConnectedPosition } from '@angular/cdk/overlay';

export enum Position {
  BOTTOM_LEFT = 'BOTTOM_LEFT',
  BOTTOM_CENTER = 'BOTTOM_CENTER',
  BOTTOM_RIGHT = 'BOTTOM_RIGHT',
  RIGHT_CENTER = 'RIGHT_CENTER',
  RIGHT_BOTTOM = 'RIGHT_BOTTOM',
  RIGHT_TOP = 'RIGHT_TOP',
  LEFT_BOTTOM = 'LEFT_BOTTOM',
  LEFT_CENTER = 'LEFT_CENTER',
  LEFT_TOP = 'LEFT_TOP',
  TOP_LEFT = 'TOP_LEFT',
  TOP_CENTER = 'TOP_CENTER',
  TOP_RIGHT = 'TOP_RIGHT',
}

export const POSITION_MAP = new Map<Position, ConnectedPosition>([
  [
    Position.BOTTOM_RIGHT,
    {
      overlayX: 'end',
      overlayY: 'top',
      originX: 'end',
      originY: 'bottom',
      offsetY: 10,
    },
  ],
  [
    Position.BOTTOM_CENTER,
    {
      overlayX: 'center',
      overlayY: 'top',
      originX: 'center',
      originY: 'bottom',
      offsetY: 10,
    },
  ],
  [
    Position.BOTTOM_LEFT,
    {
      overlayX: 'start',
      overlayY: 'top',
      originX: 'start',
      originY: 'bottom',
      offsetY: 10,
    },
  ],
  [
    Position.RIGHT_BOTTOM,
    {
      overlayX: 'start',
      overlayY: 'bottom',
      originX: 'end',
      originY: 'bottom',
      offsetX: 10,
    },
  ],
  [
    Position.RIGHT_CENTER,
    {
      overlayX: 'start',
      overlayY: 'center',
      originX: 'end',
      originY: 'center',
      offsetX: 10,
    },
  ],
  [
    Position.RIGHT_TOP,
    {
      overlayX: 'start',
      overlayY: 'top',
      originX: 'end',
      originY: 'top',
      offsetX: 10,
    },
  ],
  [
    Position.LEFT_BOTTOM,
    {
      overlayX: 'end',
      overlayY: 'bottom',
      originX: 'start',
      originY: 'bottom',
      offsetX: -10,
    },
  ],
  [
    Position.LEFT_CENTER,
    {
      overlayX: 'end',
      overlayY: 'center',
      originX: 'start',
      originY: 'center',
      offsetX: -10,
    },
  ],
  [
    Position.LEFT_TOP,
    {
      overlayX: 'end',
      overlayY: 'top',
      originX: 'start',
      originY: 'top',
      offsetX: -10,
    },
  ],
  [
    Position.TOP_LEFT,
    {
      overlayX: 'start',
      overlayY: 'bottom',
      originX: 'start',
      originY: 'top',
      offsetY: -10,
    },
  ],
  [
    Position.TOP_CENTER,
    {
      overlayX: 'center',
      overlayY: 'bottom',
      originX: 'center',
      originY: 'top',
      offsetY: -10,
    },
  ],
  [
    Position.TOP_RIGHT,
    {
      overlayX: 'end',
      overlayY: 'bottom',
      originX: 'end',
      originY: 'top',
      offsetY: -10,
    },
  ],
]);
